import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoomService {
  routeParams: any;
  groupsubjs: any[];
  groupsubj: any;
  onGroupsubjsChanged: BehaviorSubject<any>;
  onGroupsubjChanged: BehaviorSubject<any>;
  constructor(private _httpClient: HttpClient) {
    this.onGroupsubjsChanged = new BehaviorSubject({});
    this.onGroupsubjChanged = new BehaviorSubject({});
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    this.routeParams = route.params;

    return new Promise<void>((resolve, reject) => {
      Promise.all([]).then(() => {
        resolve();
      }, reject);
    });
  }


  getDataUserbyUserID(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/getDataUserbyUserID`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  getPerson(personNo: string) {
    return this._httpClient
      .get<any>(`${environment.apiUrl}/person/get/${encodeURIComponent(personNo)}`)
      .toPromise();
  }

  getProfileUserPost(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/getProfilePost`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  updateProfilePost(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/updateProfilePost`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }


  updateImageCover(data) {
    const payload = { ...data };

    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/updateImageCover`, payload)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  updateImageProfile(data) {
    const payload = { ...data };

    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/updateImageProfile`, payload)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }


  getCheckClassRoom(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.get<any>(`${environment.apiUrl}/academic/getCheckClassRoom?ids=${data.Ids}&date=${data.date}`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });

  }
  saveCheckClass(data) {

    return new Promise<any>((resolve, reject) => {
      this._httpClient.post<any>(`${environment.apiUrl}/academic/saveCheckClass`, data).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }
  getMemberInRoom(roomID) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.get<any>(`${environment.apiUrl}/classroomonline/${roomID}/members`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getWorkInRoom(roomID) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.get<any>(`${environment.apiUrl}/classroomonline/${roomID}/work`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  createdZoomRoom(data) {
    console.log(data)
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/zoom/createMeeting`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }
  getFeed(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .get<any>(`${environment.apiUrl}/classroomonline/${data}/getPost`)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }
  postToFeed(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/${data.RoomID}/post`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  postComment(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/${data.RoomID}/postcomment`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  deletePost(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/post/${data.PostID}/delete`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  updatePost(data) {
    console.log(data);
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/post/update`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  deleteComm(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/postcomment/${data.ComtID}/deletecomment`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  updateComm(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/postcomment/update`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  likePost(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/post/${data.PostID}/like`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }


  favoritesPost(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/post/${data.PostID}/favoritesPost`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }


  removefavoritesPost(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/post/${data.PostID}/removefavoritesPost`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }



  reactPost(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/post/react`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }



  getDetailReaction(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/post/reactiondetail`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }


  getAllPost() {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .get<any>(`${environment.apiUrl}/classroomonline/getAllPost`)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }


  followAuthor(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/followAuthor`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }


  getFollowers(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/getFollowers`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  getFollowings(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/getFollowing`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }


  removeFollower(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/removeFollower`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

}
